import apiHttpClient from "./ApiHttpService";

export default class ActivityService {
  getActivityInfos(costBearerType, lang) {
    let url = `trs/mobile/Activities/getActivityInfos?costBearerType=${costBearerType}&language=${lang}`;
    return apiHttpClient.get(url);
  }
}
